//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
import "../no/DisplayableObject.js";
let d=[[[0,"GridOverhang",1,0],[0,"GridSpacing",1,0],[0,"LabelDivisor",1,0],[0,"LabelGap",1,0],[0,"LineColor",1,0],[0,"LineFont",1,0],[0,"LineWidth",1,0],[0,"LocationRelativeGridHorizontal",1,0],[0,"LocationRelativeGridValue",1,0],[0,"LocationRelativeGridVertical",1,0],[0,"ReferenceXAxisLabel",1,0],[0,"ReferenceYAxisLabel",1,0],[0,"ReferenceZAxisLabel",1,0],[0,"ShowHorizontalGridLines",1,0],[0,"ShowVerticalGridLines",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.ProductGridStyleBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.ProductGridStyleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.ProductGridStyleBuilder.GridLabelLocation = Object.freeze({
    "Before" : "Before", "After" : "After", "Above" : "Above", "Below" : "Below"});

SPLM.Annotations.ProductGridStyleBuilder.HorizontalLabelDisplay = Object.freeze({
    "Before" : "Before", "After" : "After", "BeforeAfter" : "BeforeAfter", "None" : "None"});

SPLM.Annotations.ProductGridStyleBuilder.VerticalLabelDisplay = Object.freeze({
    "Below" : "Below", "Above" : "Above", "AboveBelow" : "AboveBelow", "None" : "None"});

export default SPLM;